import { Component } from '@angular/core';
import {Router, NavigationEnd} from "@angular/router";
import { AuthenticationService } from './_services/authentication.service';
import { AuthGuard } from './_guards/auth.guard';
import { User } from './_models/user';
import { Permissions } from './_models/permissions';
declare let ga: Function;

//Permissions
@Component({
  moduleId: module.id,
  selector: 'app-root',
  templateUrl: 'app.component.html',
  styleUrls: ['app.component.css']
})

export class AppComponent {

  constructor(private authGuard: AuthGuard,
    private authenticationService: AuthenticationService,
    public router: Router) {
    this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
          ga('set', 'page', event.urlAfterRedirects);
          ga('send', 'pageview');
      }
    });
  }

  logout() {
    this.authenticationService.logout();
  }

}




// WEBPACK FOOTER //
// ./src/app/app.component.ts